import { ControllerStore } from '@ayocore/platform/client/controllers/ControllerStore';
import logger from '@ayocore/platform/common/helpers/logger';
import type { BranchDealStats, DealReportClient } from '../shared/reportTypes';

/** Данные одного экземпляра виджета сделок филиала. */
export class BranchDealsWidgetController extends ControllerStore<{
  stats: BranchDealStats | null;
}> {
  private loadVersion = 0;

  constructor(private readonly repository: Pick<DealReportClient, 'getWelcomeBranchDealStats'>) {
    super({ stats: null });
  }

  async load(): Promise<void> {
    const version = ++this.loadVersion;
    try {
      const stats = await this.repository.getWelcomeBranchDealStats();
      if (version === this.loadVersion) this.setState({ stats });
    } catch (error) {
      if (version === this.loadVersion) logger.error('Failed to load branch deal stats:', error);
    }
  }

  cancelLoad(): void {
    this.loadVersion += 1;
  }
}
